const fontFamily = "\"Open Sans\", \"Segoe UI\", Tahoma, sans-serif";
export { fontFamily };

//# sourceMappingURL=index206.js.map